import { useLoginState } from '#src/app/shared/hooks/session';

export function useIsSecureGuest(doubleOptinEnabledNewUser: boolean): boolean | undefined {
	const loginState = useLoginState();
	if (loginState !== 'GUEST') return undefined;
	return doubleOptinEnabledNewUser;
}
